import { apiEmpleo } from "../../util/ApiEmpleo";

const apiDeleteContactServiceHolderRelationship = async (
  relationshipId: string
) => {
  let res = await apiEmpleo.delete(
    `contact_service_holder_relationships/${relationshipId}`
  );

  return res;
};

export { apiDeleteContactServiceHolderRelationship };
